"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = App;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _Template = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Template"));

var _Logo = _interopRequireWildcard(require("configurator-studio-arkitekter-components/dist/common/components/Logo"));

var _context2 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/context"));

var _context3 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Post/context"));

var _externalContext = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/externalContext"));

var _localStorage = require("configurator-studio-arkitekter-components/dist/common/utils/localStorage");

var _memoStorage = require("configurator-studio-arkitekter-components/dist/common/utils/memoStorage");

var _messages = _interopRequireDefault(require("../../config/constants/messages"));

var _labels = _interopRequireDefault(require("../../config/constants/labels"));

var _titles = _interopRequireDefault(require("../../config/constants/titles"));

var _routes = _interopRequireDefault(require("../../config/constants/routes"));

var _menus = _interopRequireDefault(require("../../config/constants/menus"));

var _Configurator = _interopRequireDefault(require("../Configurator"));

var _BlankScreen = _interopRequireDefault(require("../BlankScreen"));

var _utils = require("../Configurator/utils");

var _defaultAppData = _interopRequireDefault(require("../../defaultAppData"));

var _menu = _interopRequireWildcard(require("./menu"));

var _topMenu = _interopRequireDefault(require("./topMenu"));

var _materialTheme = require("./materialTheme");

// noinspection ES6UnusedImports
var style = require("./style_css.js")["default"];

var runStyle = require("./run_css.js")["default"];

var ThemedTemplate;

function App(props) {
  var _data$settings, _data$settings2, _data$settings2$basic, _data$settings2$basic2, _data$settings3, _data$settings3$basic, _data$settings3$basic2, _data$settings4, _data$settings4$basic, _data$settings5, _data$settings5$basic;

  var context = (0, _react.useContext)(_Wapp.WappContext);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
      externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var postContext = (0, _react.useContext)(_context3["default"]);
  var post = postContext.post;
  var wapp = context.wapp;
  /*for easier development*/

  if (wapp.globals.DEV) {//post.content = JSON.stringify(defaultAppData)
  }

  var utils = (0, _getUtils["default"])(context);
  var subscribe = props.subscribe;

  if (!ThemedTemplate) {
    ThemedTemplate = (0, _withMaterial.withMaterialTheme)({
      theme: _materialTheme.materialTheme,
      mediaQuery: _materialTheme.materialMediaQuery,
      classNamePrefix: wapp.globals.WAPP
    }, _Template["default"]);
  }

  wapp.styles.use(style);

  if (wapp.globals.NAME === wapp.globals.RUN) {
    wapp.styles.use(runStyle);
  }

  var container = (0, _react.useRef)();

  var _useState = (0, _react.useState)(utils.getRequestUrl()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      url = _useState2[0],
      setUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(externalSettings.fullpage ? "fixed" : externalSettings.position ? externalSettings.position : wapp.globals.NAME === wapp.globals.RUN ? "fixed" : "sticky"),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
      position = _useState4[0];

  var _useState5 = (0, _react.useState)(externalSettings.fullpage || externalSettings.fullscreen ? true : wapp.globals.NAME === wapp.globals.RUN),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
      fullscreen = _useState6[0];

  var storageName = post !== null && post !== void 0 && post._id ? wapp.globals.NAME + "_" + (post === null || post === void 0 ? void 0 : post._id) : wapp.globals.NAME;

  function onLocationChange(_x) {
    return _onLocationChange.apply(this, arguments);
  }

  function _onLocationChange() {
    _onLocationChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(newUrl) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (url !== newUrl) {
                setUrl(newUrl);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onLocationChange.apply(this, arguments);
  }

  (0, _react.useEffect)(function () {
    var unsub = subscribe.locationChange(onLocationChange);
    return function useUnsubscribe() {
      unsub();
    };
  }, [url]);

  var storage = function storage(data, memo) {
    if (memo) {
      return (0, _memoStorage.storage)(data ? data : {}, storageName);
    }

    return (0, _localStorage.storage)(data, storageName);
  };

  var template = {};
  var appContext = {
    messages: _messages["default"],
    labels: _labels["default"],
    titles: _titles["default"],
    routes: _routes["default"],
    menus: _menus["default"],
    storage: storage,
    template: template
  };

  var _getDataAndInitialCon = (0, _utils.getDataAndInitialConfiguration)({
    context: context,
    appContext: appContext,
    postContext: postContext
  }),
      initialConfiguration = _getDataAndInitialCon.initialConfiguration,
      data = _getDataAndInitialCon.data;

  if (!initialConfiguration) {
    initialConfiguration = {};
  }

  var _useState7 = (0, _react.useState)(initialConfiguration),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      configuration = _useState8[0],
      _setConfiguration2 = _useState8[1];

  if ((_data$settings = data.settings) !== null && _data$settings !== void 0 && _data$settings.context) {
    Object.keys(data.settings.context).forEach(function (constantsName) {
      if (appContext[constantsName]) {
        Object.keys(data.settings.context[constantsName]).forEach(function (propertyName) {
          appContext[constantsName][propertyName] = data.settings.context[constantsName][propertyName];
        });
      }
    });
  }

  var isAuthorOrAdmin = (0, _utils.getIsAuthorOrAdmin)({
    appContext: appContext,
    postContext: postContext
  });
  var configuratorContextObject = (0, _react.useRef)({
    data: data,
    configuration: configuration,
    translate: function translate(a) {
      return (0, _utils.translate)(a, configuration.selectedLang);
    }
  });
  var configuratorContext = configuratorContextObject.current;

  var configurationChangeHandler = function configurationChangeHandler(configuration) {
    var tempModel = configuratorContext.configuration.selectedModel;
    configuratorContext.configuration = configuration;

    if (tempModel !== configuration.selectedModel) {
      menuProps.configuratorContext = configuratorContext;
      menuElement.actions.setMenu((0, _menu["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, {
        appContext: appContext,
        context: context
      }), menuProps)));
    } else {
      (0, _menu.updateMenuLabels)({
        configuratorContext: configuratorContext,
        menuLabels: menuLabels,
        appContext: appContext
      });
    }
  };

  configuratorContext.setConfiguration = function (newConfiguration) {
    return (0, _utils.setConfiguration)({
      newConfiguration: newConfiguration,
      configuration: configuration,
      data: data,
      isAuthorOrAdmin: isAuthorOrAdmin,
      onChange: configurationChangeHandler,
      _setConfiguration: function _setConfiguration(configuration) {
        configuratorContext.configuration = configuration;

        configuratorContext.translate = function (a) {
          return (0, _utils.translate)(a, configuration.selectedLang);
        };

        return _setConfiguration2(configuration);
      },
      storage: storage
    });
  };

  var menuLabels = {};
  var menuProps = {
    externalContext: externalContext,
    postContext: postContext,
    configuratorContext: configuratorContext,
    collectMenuLabelsUpdate: function collectMenuLabelsUpdate(key, data) {
      menuLabels[key] = data;
    }
  };
  var showConfigurator = (post === null || post === void 0 ? void 0 : post._id) && data.models;
  var menuElement = {};
  return /*#__PURE__*/_react["default"].createElement(_context2["default"].Provider, {
    value: appContext
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: container,
    className: style.app
  }, /*#__PURE__*/_react["default"].createElement(ThemedTemplate, {
    position: position,
    fullscreen: fullscreen,
    getMenu: function getMenu(p) {
      return (0, _menu["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), menuProps));
    },
    getTopMenu: function getTopMenu(p) {
      return (0, _topMenu["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), menuProps));
    },
    menuProps: {
      effect: function effect(_ref) {
        var actions = _ref.actions;
        return menuElement.actions = actions;
      }
    },
    Logo: !((_data$settings2 = data.settings) !== null && _data$settings2 !== void 0 && (_data$settings2$basic = _data$settings2.basic_settings) !== null && _data$settings2$basic !== void 0 && (_data$settings2$basic2 = _data$settings2$basic.logo) !== null && _data$settings2$basic2 !== void 0 && _data$settings2$basic2.disable) ? function () {
      return /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
        type: "header",
        configuratorContext: configuratorContext
      });
    } : null,
    FooterLogo: !((_data$settings3 = data.settings) !== null && _data$settings3 !== void 0 && (_data$settings3$basic = _data$settings3.basic_settings) !== null && _data$settings3$basic !== void 0 && (_data$settings3$basic2 = _data$settings3$basic.footer_logo) !== null && _data$settings3$basic2 !== void 0 && _data$settings3$basic2.disable) ? function () {
      return /*#__PURE__*/_react["default"].createElement(_Logo.SA, {
        type: "footer",
        configuratorContext: configuratorContext
      });
    } : null,
    title: (0, _utils.translate)((_data$settings4 = data.settings) === null || _data$settings4 === void 0 ? void 0 : (_data$settings4$basic = _data$settings4.basic_settings) === null || _data$settings4$basic === void 0 ? void 0 : _data$settings4$basic.short_name, initialConfiguration.selectedLang),
    effect: function effect(p) {
      template.actions = p === null || p === void 0 ? void 0 : p.actions;
    },
    copyright: (0, _utils.translate)((_data$settings5 = data.settings) === null || _data$settings5 === void 0 ? void 0 : (_data$settings5$basic = _data$settings5.basic_settings) === null || _data$settings5$basic === void 0 ? void 0 : _data$settings5$basic.footer_copyright, initialConfiguration.selectedLang)
  }, showConfigurator ? /*#__PURE__*/_react["default"].createElement(_Configurator["default"], {
    initialConfiguration: initialConfiguration,
    onChange: configurationChangeHandler
  }) : /*#__PURE__*/_react["default"].createElement(_BlankScreen["default"], null))));
}